import React, { createContext, useContext } from 'react';
const ListContext = createContext(undefined);
export const ListProvider = ({ spacing, direction, children }) => (React.createElement(ListContext.Provider, { value: {
        spacing,
        direction,
    } }, children));
export const useList = () => {
    const context = useContext(ListContext);
    if (context === undefined) {
        throw new Error('useList must be used within a ListProvider');
    }
    return context;
};
//# sourceMappingURL=ListContext.js.map